import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {Checkup, CheckupComparison, ElectionEventLine} from '../../models/Checkup';


@Component({
  selector: 'app-audit-log',
  templateUrl: 'audit-log.component.html',
  styleUrls: ['./audit-log.component.less', '../../shared/common.less']
})

export class AuditLogComponent implements OnInit, OnChanges {
  @Input() auditEvents: ElectionEventLine[];
  @Input() auditSuccess: boolean;
  @Output() reportDownload = new EventEmitter();
  filterValue = 'tous';
  targetValue = 'tous';
  filteredAuditLines: ElectionEventLine[] = [];

  ngOnInit() {
    // Initialiser les données filtrées au chargement
    this.onFilterChange();
  }

  ngOnChanges(changes: SimpleChanges) {
    // Mettre à jour les données filtrées quand auditComparisons change
    if (changes['auditEvents'] && this.auditEvents) {
      this.onFilterChange();
    }
  }

  downloadReport() {
    this.reportDownload.emit();
  }

  onFilterChange() {
    if (!this.auditEvents) {
      this.filteredAuditLines = [];
      return;
    }
    switch (this.filterValue) {
      case 'tous':
        this.filteredAuditLines = this.auditEvents;
        break;
      default:
        this.filteredAuditLines = this.auditEvents.filter(audit => audit.type === this.filterValue);
    }
    switch (this.targetValue) {
      case 'tous':
        this.filteredAuditLines = this.auditEvents;
        break;
      default:
        this.filteredAuditLines = this.filteredAuditLines.filter(audit => audit.target === this.targetValue);
    }
  }

  formatTargetLine(target: string): string {
    switch (target) {
      case 'voters': return 'Liste électeurs';
      case 'assessors': return 'Assesseurs';
      case 'votedList': return 'Liste électorale';
      case 'candidatesList': return 'Liste des candidats';
      default: return 'Scrutin';
    }
  }

  formatTypeAction(action: string): string {
    switch (action) {
      case 'creation': { return 'Création'; }
      case 'sealing': { return 'Scellement'; }
      case 'changeMail': { return 'Changement d\'email électeur'; }
      case 'changeMailA': { return 'Changement d\'email assesseur'; }
      case 'opening': { return 'Ouverture'; }
      case 'assessorSuspend': { return 'Suspension par assesseur'; }
      case 'assessorReprise': { return 'Reprise par assesseur'; }
      case 'suspension': { return 'Suspension'; }
      case 'reprise': { return 'Reprise'; }
      case 'relaunch': { return 'Relance'; }
      case 'unsealing': { return 'Descellement'; }
      case 'closing': { return 'Clôture'; }
      default: return action;
    }
  }

  formatDate(date: string): string {
    if (!date) {
      return '';
    }
    return new Date(date).toLocaleString();
  }
}
